/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.13",
    versionName: "0.2.0-nightly.2025.7.13",
    versionChannel: "nightly",
    buildDate: "2025-07-13T00:08:29.366Z",
    commitHash: "8675b29ceee9b1287716cdfc228d5eff5a7aee53",
};
